import React from "react";
import { Grid, Box, Typography, SvgIcon } from "@material-ui/core";
import { PaperButton, IntroText } from "../../../components";
import { COUNTRIES } from "../../../constants";
import { useTranslation } from "react-i18next";

const ScheduleCountrySelect = ({ setSelectedCountry }) => {
  const { t } = useTranslation();

  return (
    <>
      <IntroText>{t("schedule.country_select.intro_text")}</IntroText>
      <Grid container direction="row" spacing={1}>
        {COUNTRIES.map(country => (
          <Grid item xs={6} key={`country-${country.iso_alpha_2}`}>
            <PaperButton
              onClick={() => setSelectedCountry(country.iso_alpha_2)}
              data-cy={`button-country-${country.iso_alpha_2}`}
            >
              <Box mb={1}>
                <SvgIcon fontSize="large">{country.flag_icon}</SvgIcon>
              </Box>
              <Typography variant="h6" component="h2">
                {country.label}
              </Typography>
            </PaperButton>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export { ScheduleCountrySelect };
